<template>
    <transition name="fade">
        <div
            v-show="true"
            role="alert"
            aria-live="assertive"
            class="md: flex w-full items-center justify-center bg-theme-bg py-1 text-xs text-theme-text"
        >
            <p class="mb-0 text-center">{{ localizations[lang].networkIsOffline }}</p>
        </div>
    </transition>
</template>
<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState(['ui', 'localizations', 'lang']),
    },
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    @apply transform transition-opacity duration-200;
}

.fade-enter,
.fade-leave-to {
    @apply -translate-y-14 opacity-0;
}
</style>
